import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/sign-up.jpg'
import _imports_1 from '@/assets/images/logo-big.svg'
import _imports_2 from '@/assets/images/white-logo-big.svg'
import _imports_3 from '@/assets/images/icons/google.svg'
import _imports_4 from '@/assets/images/icons/facebook2.svg'
import _imports_5 from '@/assets/images/icons/apple.svg'


const _hoisted_1 = { class: "bg-white dark:bg-[#0a0e19] py-[60px] md:py-[80px] lg:py-[120px] xl:py-[135px]" }
const _hoisted_2 = { class: "mx-auto px-[12.5px] md:max-w-[720px] lg:max-w-[960px] xl:max-w-[1255px]" }
const _hoisted_3 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-[25px] items-center" }
const _hoisted_4 = { class: "xl:ltr:pl-[90px] xl:rtl:pr-[90px] 2xl:ltr:pl-[120px] 2xl:rtl:pr-[120px] order-1 lg:order-2" }
const _hoisted_5 = {
  key: 0,
  class: "mb-4 bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded"
}
const _hoisted_6 = {
  key: 1,
  class: "mb-4 bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded"
}
const _hoisted_7 = { class: "mb-[15px] relative" }
const _hoisted_8 = { class: "mb-[15px] relative" }
const _hoisted_9 = {
  class: "mb-[15px] relative",
  id: "passwordHideShow"
}
const _hoisted_10 = ["type"]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "flex items-center justify-center gap-[5px]" }
const _hoisted_13 = {
  key: 0,
  class: "material-symbols-outlined"
}
const _hoisted_14 = {
  key: 1,
  class: "inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"
}
const _hoisted_15 = { class: "leading-[1.6]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "xl:ltr:-mr-[25px] xl:rtl:-ml-[25px] 2xl:ltr:-mr-[45px] 2xl:rtl:-ml-[45px] rounded-[25px] order-2 lg:order-1" }, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "sign-up-image",
            class: "rounded-[25px]"
          })
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[10] || (_cache[10] = _createStaticVNode("<img src=\"" + _imports_1 + "\" alt=\"logo\" class=\"inline-block dark:hidden\"><img src=\"" + _imports_2 + "\" alt=\"logo\" class=\"hidden dark:inline-block\"><div class=\"my-[17px] md:my-[25px]\"><h1 class=\"font-semibold text-[22px] md:text-xl lg:text-2xl mb-[5px] md:mb-[7px]\"> Sign Up to Trezo Dashboard </h1><p class=\"font-medium lg:text-md text-[#445164] dark:text-gray-400\"> Sign Up with social account or enter your details </p></div>", 3)),
          (_ctx.errorMessage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.errorMessage), 1))
            : _createCommentVNode("", true),
          (_ctx.successMessage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.successMessage), 1))
            : _createCommentVNode("", true),
          _cache[11] || (_cache[11] = _createStaticVNode("<div class=\"flex items-center justify-between mb-[20px] md:mb-[23px] gap-[12px]\"><div class=\"grow\"><button type=\"button\" class=\"block text-center w-full rounded-md transition-all py-[8px] md:py-[10.5px] px-[15px] md:px-[25px] text-black dark:text-white border border-[#D6DAE1] bg-white dark:bg-[#0a0e19] dark:border-[#172036] shadow-sm hover:border-primary-500\"><img src=\"" + _imports_3 + "\" class=\"inline-block\" alt=\"google\"></button></div><div class=\"grow\"><button type=\"button\" class=\"block text-center w-full rounded-md transition-all py-[8px] md:py-[10.5px] px-[15px] md:px-[25px] text-black dark:text-white border border-[#D6DAE1] bg-white dark:bg-[#0a0e19] dark:border-[#172036] shadow-sm hover:border-primary-500\"><img src=\"" + _imports_4 + "\" class=\"inline-block\" alt=\"google\"></button></div><div class=\"grow\"><button type=\"button\" class=\"block text-center w-full rounded-md transition-all py-[8px] md:py-[10.5px] px-[15px] md:px-[25px] text-black dark:text-white border border-[#D6DAE1] bg-white dark:bg-[#0a0e19] dark:border-[#172036] shadow-sm hover:border-primary-500\"><img src=\"" + _imports_5 + "\" class=\"inline-block\" alt=\"google\"></button></div></div>", 1)),
          _createElementVNode("div", _hoisted_7, [
            _cache[5] || (_cache[5] = _createElementVNode("label", { class: "mb-[10px] md:mb-[12px] text-black dark:text-white font-medium block" }, " Full Name ", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fullName) = $event)),
              type: "text",
              class: "h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500",
              placeholder: "Enter your full name"
            }, null, 512), [
              [_vModelText, _ctx.fullName]
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[6] || (_cache[6] = _createElementVNode("label", { class: "mb-[10px] md:mb-[12px] text-black dark:text-white font-medium block" }, " Email Address ", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.email) = $event)),
              type: "email",
              class: "h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500",
              placeholder: "example@clickai.live"
            }, null, 512), [
              [_vModelText, _ctx.email]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _cache[7] || (_cache[7] = _createElementVNode("label", { class: "mb-[10px] md:mb-[12px] text-black dark:text-white font-medium block" }, " Password ", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.password) = $event)),
              type: _ctx.showPassword ? 'text' : 'password',
              class: "h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500",
              id: "password",
              placeholder: "Type password"
            }, null, 8, _hoisted_10), [
              [_vModelDynamic, _ctx.password]
            ]),
            _createElementVNode("button", {
              class: "absolute text-lg ltr:right-[20px] rtl:left-[20px] bottom-[12px] transition-all hover:text-primary-500",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.togglePassword && _ctx.togglePassword(...args))),
              type: "button"
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(_ctx.showPassword ? 'ri-eye-line' : 'ri-eye-off-line')
              }, null, 2)
            ])
          ]),
          _createElementVNode("button", {
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleSignUp && _ctx.handleSignUp(...args))),
            disabled: _ctx.isLoading,
            type: "submit",
            class: "md:text-md block w-full text-center transition-all rounded-md font-medium my-[20px] md:my-[25px] py-[12px] px-[25px] text-white bg-primary-500 hover:bg-primary-400 disabled:opacity-70 disabled:cursor-not-allowed"
          }, [
            _createElementVNode("span", _hoisted_12, [
              (!_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("i", _hoisted_13, " person_4 "))
                : _createCommentVNode("", true),
              (_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_14))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_ctx.isLoading ? 'Signing Up...' : 'Sign Up'), 1)
            ])
          ], 8, _hoisted_11),
          _cache[12] || (_cache[12] = _createElementVNode("p", { class: "leading-[1.6]" }, [
            _createTextVNode(" By confirming your email, you agree to our "),
            _createElementVNode("a", {
              href: "#",
              class: "font-medium text-black dark:text-white transition-all hover:text-primary-500"
            }, " Terms of Service "),
            _createTextVNode(" and that you have read and understood our "),
            _createElementVNode("a", {
              href: "#",
              class: "font-medium text-black dark:text-white transition-all hover:text-primary-500"
            }, " Privacy Policy ")
          ], -1)),
          _createElementVNode("p", _hoisted_15, [
            _cache[9] || (_cache[9] = _createTextVNode(" Already have an account. ")),
            _createVNode(_component_RouterLink, {
              to: "/authentication/sign-in",
              class: "text-primary-500 transition-all font-semibold hover:underline"
            }, {
              default: _withCtx(() => _cache[8] || (_cache[8] = [
                _createTextVNode(" Sign In ")
              ])),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}